import { render, staticRenderFns } from "./Main-Signup.vue?vue&type=template&id=68b5b1af&"
import script from "./Main-Signup.vue?vue&type=script&lang=js&"
export * from "./Main-Signup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports